import * as React from 'react';

import { cn } from '@/lib/utils';
import { inputFieldVariants, type InputFieldVariantProps } from '@/components/ui/field-variants';

type TextareaProps = React.ComponentProps<'textarea'> & InputFieldVariantProps;

function Textarea({ className, variant = 'default', placeholder, ...props }: TextareaProps) {
    return (
        <textarea
            data-slot="textarea"
            className={cn(inputFieldVariants({ variant }), 'field-sizing-content', className)}
            placeholder={placeholder ?? (variant === "floating" ? " " : undefined)}
            {...props}
        />
    );
}

export { Textarea };
